<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="districts"
        :table-select="false"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="区域编号">
              <el-input v-model.trim="filter.districtNO" placeholder="请输入区域编号" clearable/>
            </el-form-item>
            <el-form-item label="区域名称">
              <el-input v-model.trim="filter.districtName" placeholder="请输入区域名称" clearable/>
            </el-form-item>
            <el-form-item label="上级区域">
              <el-input v-model.trim="filter.parentName" placeholder="请输入上级区域名称" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <district-edit ref="districtEdit" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import DistrictEdit from "./DistrictEdit.vue";
  export default {
    name: "DistrictList",
    components: { ViewTable, DistrictEdit },

    data() {
      return {
        limits: {
          addAuth: this.$auth(158),
          editAuth: this.$auth(159),
          delAuth: this.$auth(160),
        },
        filter: {
          districtNO: "",
          districtName: "",
          parentName: "",
        },
        columnsProperty: [
          {
            key: "districtNO",
            width: 120,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      addEditHandle(row) {
        this.$refs.districtEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "districts", row.districtId).then((resp) => {
          if (resp.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
